import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import style from './RegistrationInfoResult.module.scss';
import Tag from '../Tag';
import Rosneft from '../../../assets/images/Tags/Rosneft.svg';
import Basket from '../../../assets/images/Tags/Basket.svg';
import Bur from '../../../assets/images/Tags/Bur.svg';
import Cars from '../../../assets/images/Tags/Cars.svg';
import Control from '../../../assets/images/Tags/Control.svg';
import Defence from '../../../assets/images/Tags/Defence.svg';
import Tek from '../../../assets/images/Tags/Tek.svg';
import Gas from '../../../assets/images/Tags/Gas.svg';
import Port from '../../../assets/images/Tags/Port.svg';
import Gerb from '../../../assets/images/Tags/Gerb.svg';
import RGD from '../../../assets/images/Tags/RGD.svg';
import InterPAO from '../../../assets/images/Tags/InterPAO.svg';
import TimeClockFileBlue from '../../../assets/images/TimeClockFileBlue.svg';
import Delete from '../../../assets/images/Delete.svg';
import { IState } from '../../../types/interfaces';
import ServerError from '../Errors/ServerError';
import NotFoundWithMargin from '../Errors/NotFoundWithMargin';

export const tagGenerator = (text: string) => {
  switch (text) {
    case 'Продажа нефтепродуктов':
      return <Tag src={Rosneft} text="Продажа нефтепродуктов" color="0,0,0" key={text} />;
    case 'Роснефть':
      return <Tag src={Rosneft} text="Роснефть" color="0,0,0" key={text} />;
    case 'Интернет-Магазин':
      return <Tag src={Basket} text="Интернет-магазин" color="0,157,221" key={text} />;
    case 'РЖД':
      return <Tag src={RGD} text="РЖД" color="226,26,26" key={text} />;
    case 'ИРАО':
      return <Tag src={InterPAO} text="Интер РАО" color="255,121,0" key={text} />;
    case 'Оборонэнерго':
      return <Tag src={Defence} text="Оборонэнерго" color="255,121,0" key={text} />;
    case 'Газпром бурение':
      return <Tag src={Bur} text="Газпром бурение" color="0,158,227" key={text} />;
    case 'ТЭК Мосэнерго':
      return <Tag src={Bur} text="ТЭК Мосэнерго" color="0,158,227" key={text} />;
    case 'Русгазбурение':
      return <Tag src={Gas} text="Русгазбурение" color="0,80,159" key={text} />;
    case 'Управление заказчика':
      return <Tag src={Control} text="Управление заказчика" color="0,80,159" key={text} />;
    case 'Силовые машины':
      return <Tag src={Cars} text="Силовые машины" color="0,132,144" key={text} />;
    case 'Росморпорт':
      return <Tag src={Port} text="Росморпорт" color="0,132,144" key={text} />;
    case 'Госзакупки':
      return <Tag src={Gerb} text="Государственные закупки" color="204,0,0" key={text} />;
    case '223-ФЗ и Коммерческие закупки':
      return <Tag src={Tek} text="223-ФЗ и Коммерческие закупки" color="0,157,221" key={text} />;
    case 'Продажа имущества':
      return <Tag src={Tek} text="Продажа имущества" color="0,157,221" key={text} />;
    case 'Продажа арестованного имущества':
      return <Tag src={Tek} text="Продажа арестованного имущества" color="0,157,221" key={text} />;
    case 'Общая секция':
      return <Tag src={Tek} text="223-ФЗ и Коммерческие закупки" color="0,157,221" key={text} />;
    default:
      return <Tag src={Tek} text={text} color="0,157,221" key={text} />;
  }
};

interface ISupplier {
  inn: string;
  kpp: string;
  name: string;
  sections: { accredited_at: string; section_code: string; section_title: string }[];
  short_name: string;
}

interface IProps {
  searchResult: ISupplier[];
  errors: string;
}

const RegistrationInfoResult = ({ searchResult, errors }: IProps) => {
  const history = useHistory();

  return (
    <>
      {errors === 'NOT_FOUND' && <NotFoundWithMargin />}
      {errors && errors !== 'NOT_FOUND' && <ServerError />}
      {searchResult?.length ? (
        <table className={style.table}>
          <thead className={style.head}>
            <tr className={style.headRow}>
              <th>Организация</th>
              <th>Аккредитован на секциях</th>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <th />
            </tr>
          </thead>
          {searchResult.map((el, index) => (
            <tbody key={index.toString()} className={style.body}>
              <tr>
                <td>
                  <p className={style.title}>{el.name}</p>
                  <p className={style.description}>
                    <b>ИНН</b> {el.inn} <b>КПП</b> {el.kpp}
                  </p>
                </td>
                {!el?.sections?.length ? (
                  <td className={style.delete}>
                    <img src={Delete} alt="Организация не аккредитована" /> Организация не аккредитована
                  </td>
                ) : (
                  <td rowSpan={2}>
                    <div className={style.tagsWrapper}>
                      {el?.sections?.map((tag) => tagGenerator(tag.section_title))}
                    </div>
                  </td>
                )}
                <td>
                  <button
                    type="button"
                    className={style.btn}
                    onClick={() => {
                      history.push(`/,${el.inn},${el.kpp}`);
                    }}
                  >
                    <img src={TimeClockFileBlue} alt="Скачать" />
                    Экспресс-отчёт
                  </button>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  searchResult: state.etpRegistration.searchResult,
  errors: state.etpRegistration.errors,
});

export default connect(mapStateToProps)(RegistrationInfoResult);
